<template>
  <button v-if="!link" :class="mode">
    <slot></slot>
  </button>
  <router-link v-else :to="to" :class="mode">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      required: false,
      default: null
    },
    link: {
      type: Boolean,
      required: false,
      default: false
    },
    to: {
      type: String,
      required: false,
      default: '/'
    }
  }
}
</script>

<style scoped>
button,
a {
  text-decoration: none;
  padding: 0.5rem 1.2rem;
  font: inherit;
  font-size: .75rem;
  background-color: #363b81;
  border: 1px solid #363b81;
  color: white;
  cursor: pointer;
  margin-right: 0.5rem;
  display: inline-block;
}

a:hover,
a:active,
button:hover,
button:active {
  background-color: #262953;
  border-color: #262953;
}

.flat {
  background-color: transparent;
  color: #363b81;
  border: none;
}

.outline {
  background-color: transparent;
  border-color: #363b81;
  color: #363b81;
}

.flat:hover,
.flat:active,
.outline:hover,
.outline:active {
  background-color: #edd2ff;
}
</style>